/** AccessHub tool list — which MusicForge steps are on. Not an in-app model picker. */

const DUMP_ORIGIN = "https://proxy.vividlex.com";

export type CatalogBoard = {
  tools?: { tool_id: string }[];
  hidden?: string[];
};

export async function fetchCatalogTools(app: string): Promise<CatalogBoard> {
  const res = await fetch(
    `${DUMP_ORIGIN}/api/catalog/tools?app=${encodeURIComponent(app)}`,
  );
  if (!res.ok) throw new Error(`catalog tools ${res.status}`);
  return (await res.json()) as CatalogBoard;
}

export function toolIsOn(board: CatalogBoard | null | undefined, toolId: string): boolean {
  if (!board) return true;
  if ((board.hidden || []).includes(toolId)) return false;
  return (board.tools || []).some((t) => t.tool_id === toolId);
}
